import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=52fa651a&"
import script from "./file-upload.vue?vue&type=script&lang=js&"
export * from "./file-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports